<script>
import checkPermission from "@/utils/permission";

import { mapGetters } from "vuex";

import { getDicyType } from "@/api/dict";
import { getRefuelReport as getList } from "@/api/vehicle";
import { getList as getStaffList } from "@/api/staff.js";

import { parseTime } from "@/utils";

import Header from "@/views/components/header/index.vue";
import Footer from "@/views/components/footer/index.vue";

import { showPhoneAlarm } from "@/global/function.js";

import dayjs from "dayjs";

export default {
  components: { Header, Footer },
  data() {
    const EDate = dayjs().format("YYYY/MM/DD");
    const dayTimeStamp = +dayjs().endOf("day");
    const beforeTimeStamp = +dayjs().startOf("month");
    const SDate = dayjs(beforeTimeStamp).format("YYYY/MM/DD");

    const listQuery = {
      limit: 10,
      page: 1,
      data: {
        isInteriorCode: undefined,
        isInteriorName: "全部",
      },
      date: {
        show: false,
        min: new Date(2020, 1, 1),
        max: new Date(2030, 12, 31),
        range: SDate + " - " + EDate,
        start: beforeTimeStamp,
        end: dayTimeStamp,
        default: [new Date(SDate), new Date(EDate)],
      },
    };

    const table = {
      listLoading: false,
      fullWidth: document.documentElement.clientWidth,
      key: 0,
      total: 0,
      data: [],
    };

    return {
      listQuery,
      showStatusPicker: false,
      showRefuelPicker: false,
      refuelStatusList: [],
      statusList: [],
      interiorList: [
        { value: undefined, name: "全部" },
        { value: 0, name: "非内部车辆" },
        { label: 1, name: "内部车辆" },
      ],
      refuelCheckList: [],
      table,
    };
  },
  computed: {
    ...mapGetters({
      userid: "user/userid",
    }),
  },
  created() {
    this.getListData();
  },
  methods: {
    checkPermission,
    clickLeft() {
      this.$router.go(-1);
    },
    pickerDict(dictlist) {
      return dictlist.map((dict) => ({
        name: dict.label,
        value: dict.code,
      }));
    },
    getValue(list, value) {
      return list.find((dict) => dict.value === value) || {};
    },
    onStatusChoose(status) {
      const { value, name } = status;
      this.listQuery.data.isInteriorCode = value;
      this.listQuery.data.isInteriorName = name;
      this.showStatusPicker = false;
    },
    onRefuelChoose(refuel) {
      const { value, name } = refuel;
      this.listQuery.data.checkRefuel = value;
      this.listQuery.data.checkRefuelName = name;
      this.showRefuelPicker = false;
    },
    getStatus: function (value) {
      if (value === undefined) return "";
      return this.statusList.find((item) => +item.value === +value)?.name;
    },
    getRefuel: function (value) {
      if (value === undefined) return "";
      return this.refuelList.find((item) => +item.value === +value)?.name;
    },
    handleTableRowClick(row) {
      this.$refs.table.toggleRowExpansion(row);
    },
    formatStamp(timestamp) {
      if (typeof timestamp === "number")
        return parseTime(timestamp, "{y}-{m}-{d}  {h}:{i}:{s}");
      else return timestamp;
    },
    async getListData() {
      console.log("listQuery", this.listQuery);
      const payload = {
        page: {
          current: this.listQuery.page,
          size: this.listQuery.limit,
        },
        where: {
          "lk_drr.vehicleNo": this.listQuery.data.vehicleNo || undefined,
          "eq_drr.isInterior": this.listQuery.data.isInteriorCode,
          "ge_drr.refuelTime": dayjs(this.listQuery.date.start)
            .startOf("day")
            .format("YYYY-MM-DD HH:mm:ss"),
          "le_drr.refuelTime": dayjs(this.listQuery.date.end)
            .endOf("day")
            .format("YYYY-MM-DD HH:mm:ss"),
        },
      };
      const response = await getList(payload).catch(() => false);
      if (response) {
        const { data } = response;
        if (
          showPhoneAlarm(
            false,
            "toast",
            null,
            2000,
            data.code,
            null,
            data.message
          )
        ) {
          this.table.total = data.page.total;
          this.table.data = data.page.records;
        }
      }
    },
    formatDate(date) {
      const year = date.getFullYear();
      const month = date.getMonth();
      const day = date.getDate();
      return `${year}/${month + 1 > 9 ? month + 1 : "0" + (month + 1)}/${
        day > 9 ? day : "0" + day
      }`;
    },
    onConfirmDateChoose(date) {
      const [start, end] = date;
      this.listQuery.date.show = false;
      this.listQuery.date.range = `${this.formatDate(
        start
      )} - ${this.formatDate(end)}`;
      this.listQuery.date.start = new Date(start).getTime();
      this.listQuery.date.end = new Date(end).getTime();
    },
    openPreview(row) {
      const list = [];
      this.imgKey.forEach((key) => {
        if (row[key]) list.push(row[key]);
      });
      this.showPreview = true;
      this.showPreviewList = list;

      console.log("list", list);
    },
  },
};
</script>

<template>
  <div style="background: white">
    <Header
      :show="true"
      title="加油报表"
      left="prepage"
      :click-left="clickLeft"
    />
    <div style="padding-bottom: 8vh">
      <!-- 顶部搜索相关 Cell -->
      <div>
        <van-field v-model.trim="listQuery.data.vehicleNo" placeholder="请输入">
          <template #label>
            <span style="font-size: 2vh; color: black">车牌号</span>
          </template>
        </van-field>
        <van-cell
          :value="listQuery.data.isInteriorName"
          is-link
          @click="showStatusPicker = true"
        >
          <template #title>
            <span style="font-size: 2vh">加油类型</span>
          </template>
        </van-cell>
        <van-action-sheet
          v-model="showStatusPicker"
          :actions="interiorList"
          cancel-text="取消"
          description="请选择查询的加油类型"
          @select="onStatusChoose"
        />
        <van-cell
          :value="listQuery.date.range"
          is-link
          @click="listQuery.date.show = true"
        >
          <template #title>
            <span style="font-size: 2vh">时间区间</span>
          </template>
        </van-cell>
        <van-calendar
          v-model="listQuery.date.show"
          type="range"
          :min-date="listQuery.date.min"
          :max-date="listQuery.date.max"
          :default-date="listQuery.date.default"
          color="#ee0a24"
          :style="{ 'padding-bottom': '30px' }"
          @confirm="onConfirmDateChoose"
        />
        <div style="margin: 8px">
          <van-button
            v-if="checkPermission([428])"
            round
            block
            type="info"
            @click="getListData"
          >
            查询
          </van-button>
        </div>
      </div>
      <el-table
        ref="table"
        :data="table.data"
        style="width: 100%"
        @row-click="handleTableRowClick"
      >
        <el-table-column type="expand" width="30px">
          <template slot-scope="{ row }">
            <el-form
              label-position="left"
              label-width="100px"
              :show-message="false"
              style="padding: 0 20px"
              class="tableExpressInfo"
            >
              <el-form-item label="申请加油量">
                <span>{{ row.applyRefuelCapSum }}</span>
              </el-form-item>
              <el-form-item label="实际加油量">
                <span>{{ row.actualRefuelCapSum }}</span>
              </el-form-item>
              <el-form-item label="车辆类型">
                <span v-if="row.isInterior">内部车辆</span>
                <span v-else>非内部车辆</span>
              </el-form-item>
              <el-form-item label="里程">
                <span>{{ row.mileSum }} KM</span>
              </el-form-item>
              <el-form-item label="油耗">
                <span>{{ row.oc || 0 }} L/KM</span>
              </el-form-item>
            </el-form>
          </template>
        </el-table-column>
        <el-table-column label="序号" type="index" align="center" width="50" />
        <el-table-column
          label="车辆名称"
          prop="vehicleName"
          align="center"
          min-width="110"
          show-overflow-tooltip
        />
        <el-table-column
          label="车牌号"
          prop="vehicleNo"
          align="center"
          min-width="90"
          show-overflow-tooltip
        />

        <el-table-column
          label="加油次数"
          prop="refuelCount"
          align="center"
          min-width="80"
        />
      </el-table>
      <el-pagination
        v-show="table.total > 0"
        :total="table.total"
        background
        layout="prev, pager, next"
        :current-page.sync="listQuery.page"
        :limit.sync="listQuery.limit"
        style="margin: 0.6rem 0; text-align: center"
        @current-change="getListData"
      />
    </div>
    <Footer value="service" />
  </div>
</template>

<style scoped>
.tableExpressInfo .el-form-item {
  margin-bottom: 0 !important;
}
.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 100%;
}
</style>